import * as Yup from "yup";

export const FollowersSchema = Yup.object().shape({
//   hmusers: Yup.string(),
  instagram: Yup.string(),
  facebook: Yup.string(),
  linkedin: Yup.string(),
  youtube: Yup.string(),
  google: Yup.string(),
});
